'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('../../../../@babel/runtime/helpers/esm/extends.js');
var objectWithoutProperties = require('../../../../@babel/runtime/helpers/esm/objectWithoutProperties.js');
var React = require('react');
var PropTypes = require('prop-types');
var clsx_m = require('../../../../clsx/dist/clsx.m.js');
var withStyles = require('../styles/withStyles.js');
var capitalize = require('../utils/capitalize.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return n;
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var styles = function styles(theme) {
  return {
    root: {
      position: 'absolute',
      height: 2,
      bottom: 0,
      width: '100%',
      transition: theme.transitions.create()
    },
    colorPrimary: {
      backgroundColor: theme.palette.primary.main
    },
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main
    },
    vertical: {
      height: '100%',
      width: 2,
      right: 0
    }
  };
};
/**
 * @ignore - internal component.
 */

var TabIndicator = React__namespace.forwardRef(function TabIndicator(props, ref) {
  var classes = props.classes,
      className = props.className,
      color = props.color,
      orientation = props.orientation,
      other = objectWithoutProperties(props, ["classes", "className", "color", "orientation"]);

  return /*#__PURE__*/React__namespace.createElement("span", _extends({
    className: clsx_m(classes.root, classes["color".concat(capitalize(color))], className, orientation === 'vertical' && classes.vertical),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? TabIndicator.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes__default["default"].object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes__default["default"].string,

  /**
   * @ignore
   * The color of the tab indicator.
   */
  color: PropTypes__default["default"].oneOf(['primary', 'secondary']).isRequired,

  /**
   * The tabs orientation (layout flow direction).
   */
  orientation: PropTypes__default["default"].oneOf(['horizontal', 'vertical']).isRequired
} : void 0;
var TabIndicator$1 = withStyles(styles, {
  name: 'PrivateTabIndicator'
})(TabIndicator);

exports["default"] = TabIndicator$1;
exports.styles = styles;
